import { LicenseInfo } from "@mui/x-license";

LicenseInfo.setLicenseKey(
  "3cd92e39d606a45c64f0e4b65b7a9cc8Tz0xMTYwNzksRT0xNzg1NTQyMzk5MDAwLFM9cHJlbWl1bSxMTT1hbm51YWwsUFY9UTEtMjAyNixRPTEsQVQ9bXVsdGksS1Y9Mg=="
);
